'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('../loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

require('./PopupEmptyContent.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var PopupEmptyContent = function PopupEmptyContent(_ref) {
    var message = _ref.message,
        children = _ref.children,
        showSpinner = _ref.showSpinner;

    var messageComponent = message ? _react2.default.createElement(
        'p',
        null,
        message
    ) : null;

    return _react2.default.createElement(
        'div',
        { className: 'PopupEmptyContent' },
        messageComponent,
        _react2.default.createElement(_Spinner2.default, { show: showSpinner }),
        children
    );
};

// Styles


PopupEmptyContent.propTypes = {
    message: _propTypes2.default.string,
    showSpinner: _propTypes2.default.bool,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

exports.default = PopupEmptyContent;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/PopupEmptyContent.js
// module id = 441
// module chunks = 0